/** First character, uppercased -- the avatar fallback. */
export function getInitial(value: string | undefined | null): string {
  return value?.trim().charAt(0).toUpperCase() ?? '?';
}

export function capitalize(value: string): string {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}

/** "organization-setup" -> "Organization Setup" */
export function titleCaseFromSlug(slug: string): string {
  return slug
    .split(/[-_]/)
    .filter(Boolean)
    .map((part) => capitalize(part))
    .join(' ');
}

/** "ashok.kumar@aitglobal.com" -> "as***@aitglobal.com" */
export function maskEmail(email: string): string {
  const [local, domain] = email.split('@');
  if (!local || !domain) return email;
  const head = local.slice(0, 2);
  return `${head}${'*'.repeat(Math.max(1, local.length - 2))}@${domain}`;
}
